<a *ngIf="canShare && value" href="#" class="textContent" (click)="shareTextClicked()">{{ value }}</a>
<span *ngIf="!canShare && value">{{ value }}</span>
